<template>
	<v-container grid-list-xs>
		<v-form>
			<v-card>
				<v-card-title primary-title class="text-uppercase">
					<v-btn
						icon
						@click="
							$inertia.visit($route('central.cuisines.index'))
						"
					>
						<v-icon>mdi-arrow-left</v-icon>
					</v-btn>
					{{ $t("title.create_cuisine") }}
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<shop-form-cuisine v-model="item"></shop-form-cuisine>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						@click.native="submit()"
						:loading="item.processing"
					>
						<v-icon left>mdi-content-save</v-icon>
						{{ $t("Save") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-container>
</template>
<script>
import ShopFormCuisine from "@Shop/forms/ShopFormCuisine.vue";
export default {
	components: { ShopFormCuisine },
	props: ["data"],
	data() {
		return {
			item: this.$inertia.form({
				name: null,
				description: null,
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(this.$route("central.cuisines.store"));
		},
	},
};
</script>